import { appConfig } from '../config/runtimeConfig';

export const auth0Config = {
  domain: appConfig.auth0Domain,
  clientId: appConfig.auth0ClientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: appConfig.auth0Audience,
  },
  // Refresh tokens via the token endpoint instead of silent auth via a
  // hidden iframe.  Modern browsers (Chromium 120+) block the 3rd-party
  // cookies the iframe flow depends on.
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
};
